import { render, staticRenderFns } from "./SelectedElementsSummary.vue?vue&type=template&id=6b934e61"
import script from "./SelectedElementsSummary.vue?vue&type=script&lang=js"
export * from "./SelectedElementsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports